module.exports = __webpack_public_path__ + "assets/money.954fffc7.svg";